import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { SCAPaymentEvent } from "src/app/model/enums/sca-payment-event";
import { StorageKeys } from "src/app/model/enums/storage-keys";
import { NetaxeptPaymentContext } from "src/app/model/interfaces/netaxept-payment-context";
import { NetaxeptPaymentOptions } from "src/app/model/interfaces/netaxept-payment-options";
import { NetaxeptRegisterPaymentResponse } from "src/app/model/interfaces/netaxept-register-payment-response";
import { StorageService } from "src/app/services";
import { AppConfigService } from "src/app/services/app-config.service";
import { NetaxeptService } from "src/app/services/netaxept.service";
import { NetsPaymentService } from "src/app/services/nets-payment-service";
import { PaymentService } from "src/app/services/payment-service";
import { NetsPayment3dNotificationModalComponent } from "../modals/nets-payment-3d-notification-modal.component/nets-payment-3d-notification-modal.component";
import { NetsPaymentCancelledModalComponent } from "../modals/nets-payment-cancelled-modal.component/nets-payment-cancelled-modal.component";
import { NetsPaymentDeclinedModalComponent } from "../modals/nets-payment-declined-modal.component/nets-payment-declined-modal.component";

@Component({
    selector: 'app-netaxept-payment',
    templateUrl: 'netaxept-payment.component.html'
})
export class NetaxeptPaymentComponent implements OnInit
{
    public cardNo: string;
    public cardExpiration: string;  // MMYY
    public cardCvc: string; // XYZ
    public transactionId: string;
    public merchantId: string;
    public terminalFormAction: string;

    private readonly route: ActivatedRoute;
    private readonly storageService: StorageService;
    private readonly netaxeptService: NetaxeptService;
    private readonly paymentService: PaymentService;
    private readonly netsPaymentService: NetsPaymentService;

    @ViewChild('netsPaymentDeclinedModal', { static: true })
    public netsPaymentDeclinedModal: NetsPaymentDeclinedModalComponent;

    @ViewChild('netsPaymentCancelledModal', { static: true })
    public netsPaymentCancelledModal: NetsPaymentCancelledModalComponent;

    @ViewChild('netsPayment3dNotificationModal', { static: true })
    public netsPayment3dNotificationModal: NetsPayment3dNotificationModalComponent;

    @ViewChild('terminalForm', { static: true })
    public terminalForm: ElementRef;

    public constructor(
        route: ActivatedRoute,
        netaxeptService: NetaxeptService, 
        storageService: StorageService, 
        paymentService: PaymentService,
        netsPaymentService: NetsPaymentService,
        private environment: AppConfigService)
    {
        this.route = route;
        this.storageService = storageService;
        this.netaxeptService = netaxeptService;
        this.paymentService = paymentService;
        this.netsPaymentService = netsPaymentService;
    }

    public ngOnInit(): void 
    {
        this.merchantId = this.environment.config['nets-merchant-id'];
        this.terminalFormAction = this.environment.config['nets-terminal-url'];

        this.route.queryParamMap.subscribe(parms => {
            const paymentStatus = parms.get(StorageKeys.NetsPaymentStatus);
            switch (paymentStatus)
            {
                case 'declined':
                    this.netsPaymentDeclinedModal.open();
                    this.storageService.removeItem(StorageKeys.NetsPaymentStatus);
                    break;
                case 'cancelled':
                    this.netsPaymentCancelledModal.open();
                    this.storageService.removeItem(StorageKeys.NetsPaymentStatus);
                    break;
            }
        });
    }

    public pay(options: NetaxeptPaymentOptions): Observable<NetaxeptRegisterPaymentResponse>
    {
        const context: NetaxeptPaymentContext = {
            orderId: options.orderId,
            route: escape(options.contextRoute)
        };

        return this.netaxeptService.registerPayment(
            options.orderId,
            options.description,
            escape(JSON.stringify(context)),
            options.mobilePay).pipe(switchMap(paymentRegistrationResponse => {

            if(!paymentRegistrationResponse.PaymentMethodValid)
            {
                return of(paymentRegistrationResponse);
            }

            this.transactionId = paymentRegistrationResponse.TransactionId;

            return this.paymentService.onSCAPaymentEvent(options.orderId, SCAPaymentEvent.Ready).pipe(map(() => {

                this.netsPaymentService.setPendingOrder(options.orderId);
                window.location.href = `${this.terminalFormAction}?merchantId=${this.merchantId }&transactionId=${this.transactionId}`;
                
                return paymentRegistrationResponse;
            }));
        }));
    }
}
